
/*
	popisuje remote server avail. stat PRED zahajenim LV session, online muze byt pouze pokud CHAT_ON
*/
export enum ChatAvailabilityStateEnum {
	ONLINE = "ONLINE",
	OFFLINE = "OFFLINE",
	BUSY = "BUSY"
}

export interface ChatMachineContext {
	isError:boolean
	waitForOpCounter:number
	states:string[]
	events:string[]
  }

export interface ChatMachineSchema {
	states: {
		botLoaded: {/* az do otevreni a login volani (muze byt err, pak botError) */},
		botAvailable: {/* TRANSITIVE po uspesnem prihlaseni do chatu pri jeho otevreni*/};
		botError: {/* TRANSITIVE nepodaril se login call a zjistuje se co dal*/};
		
		botActiveOpDisabled: {/* bot disabled - INTRANET CSU}*/};
		botActiveNoOp: {/* (mozna) probihaji otazky, bez tlacitka na op LV, ktere off-shift */};
		botActiveOpBusy: {/* (mozna) probihaji otazky, bez tlacitka na op LV, ktere je */};
		botActiveOpError: {/* (mozna) probihaji otazky, bez tlacitka na op LV, ktere je nedostupne*/};
		botActiveAndWaitingToStartOfferOp: {/* (mozna) probihaji otazky, ZOBRAZENO tlacitko na op LV  */};
		
		opAvailCheck: {/* TRANSITIVEzjistovani stavu LV (napr. BUSY)*/};
		//opOpen:{/* pokud pracovni doba*/}
		
		//Tato sekce je pro BOT available
		botActiveOfferingOp: {/* pri ONLINE pred prepnutim na LV */};
		
		botErrorOpOffshift: {
			/* 
			pokud mimo pracovni dobu a je bot nedostupny -> pri kazdem dalsim dotazu musim kontrolovat dostupnost a on/off shift
			ale nechci pro-aktivne -> pretizeni systemu, pouze na dotaz uzivatele
			*/
		}
		
		//Tato sekce je pro BOT offline/err/busy ALE v pracovni dobe
		opAvailableBotError: {/* pri ONLINE pred prepnutim na LV*/};
		opErrorBotError: {/* LV je nedostupny */};
		opBusyBotError: {/* pri BUSY pred prepnutim na LV*/};
		opWaitingForGdprConsent: {/* pro zobrazeni ANO/NE na osobni udaje/gdpr */}
		opWaitingForOp1: {/* new chat req. a ceka na op. */};
		opWaitingForUser: {/* new chat req. a ceka na op. */ };
		opWaitingForOp2: {/* new chat req. a ceka na op. */};
		opDidNotStart: {/* new chat req. a ceka na op. */};
		
		opActive: {/* probiha komunikace s op LV*/};
		
		opEnded: {/* skoncena session s op LV*/};
		waitingForOpWasEndedByUser: {/*zruseno uzivatelem pri cekani na OP */}
		waitingForGdprConsentWasEndedByUser: {}
		opFeedback: {/* probiha hodnoceni LV*/};
		
	};
}

export enum ChatMachineStatesEnum {
	botLoaded = 'botLoaded',
	botAvailable = 'botAvailable',
	botActiveOpDisabled = 'botActiveOpDisabled',
	botError = 'botError',
	botActiveNoOp = 'botActiveNoOp',
	botActiveOpBusy = 'botActiveOpBusy',	
	botActiveOpError = 'botActiveOpError',	

	botActiveAndWaitingToStartOfferOp = 'botActiveAndWaitingToStartOfferOp',
	opAvailCheck = 'opAvailCheck',
	botActiveOfferingOp= 'botActiveOfferingOp',
	botErrorOpOffshift = 'botErrorOpOffshift',
	opAvailableBotError = 'opAvailableBotError',	
	opErrorBotError = 'opErrorBotError',
	opBusyBotError = 'opBusyBotError',
	opWaitingForGdprConsent = 'opWaitingForGdprConsent',
	opWaitingForOp1 = 'opWaitingForOp1',
	opWaitingForUser = 'opWaitingForUser',	
	opWaitingForOp2 = 'opWaitingForOp2',	
	opDidNotStart = 'opDidNotStart',
	opActive = 'opActive',	
	opFeedback = 'opFeedback',
	opEnded = 'opEnded',
	waitingForOpWasEndedByUser = 'waitingForOpWasEndedByUser',
	waitingForGdprConsentWasEndedByUser = 'waitingForGdprConsentWasEndedByUser'

}

export interface ChatMachineValue {
	isError?:boolean,
	waitForOpCounter?:number
	
}

export type ChatMachineEvent =
| { type: 'TESTING',value?:ChatMachineValue }
  | { type: 'BOT_ONLINE',value?:ChatMachineValue }
  | { type: 'OP_DISABLED',value?:ChatMachineValue }
  | { type: 'BOT_ONLINE_OFFER_OP',value?:ChatMachineValue }
  | { type: 'BOT_OFFLINE',value?:ChatMachineValue }
  | { type: 'SWITCH_BOT',value?:ChatMachineValue }
  | { type: 'SWITCH_OP',value?:ChatMachineValue }
  | { type: 'OP_ONLINE',value?:ChatMachineValue }
  | { type: 'OP_OFFLINE',value?:ChatMachineValue }
  | { type: 'OP_BUSY',value?:ChatMachineValue }
  | { type: 'OP_ONLINE_CHAT_ERR',value?:ChatMachineValue }
  | { type: 'OP_OFFLINE_CHAT_ERR',value?:ChatMachineValue }
  | { type: 'OP_BUSY_CHAT_ERR' ,value?:ChatMachineValue }
  | { type: 'OP_WAITING_FOR_GDPR_CONSENT' ,value?:ChatMachineValue }
  | { type: 'OP_WAITING_FOR_OP_1' ,value?:ChatMachineValue }
  | { type: 'OP_WAITING_FOR_USER' ,value?:ChatMachineValue }
  | { type: 'OP_WAITING_FOR_OP_2' ,value?:ChatMachineValue }
  | { type: 'OP_DID_NOT_START' ,value?:ChatMachineValue }
  | { type: 'OP_DID_START' ,value?:ChatMachineValue }
  | { type: 'OP_ACTIVE' ,value?:ChatMachineValue }
  | { type: 'OP_ENDED_BY_OP' ,value?:ChatMachineValue }
  | { type: 'OP_ENDED_BY_USER' ,value?:ChatMachineValue }
  | { type: 'OP_FEEDBACK' ,value?:ChatMachineValue }
  | { type: 'OP_FEEDBACK_DONE' ,value?:ChatMachineValue }
  | { type: 'OP_UNEXPECTED_ERR',value?:ChatMachineValue }
  | { type: 'OP_CONTINUE_TO_WAIT',value?:ChatMachineValue }
  | { type: 'OP_ENDED_BY_USER',value?:ChatMachineValue }
  
  export enum ChatMachineEventEnum {
  TESTING = 'TESTING',
  BOT_ONLINE = 'BOT_ONLINE',
  OP_DISABLED = 'OP_DISABLED',
  BOT_ONLINE_OFFER_OP = 'BOT_ONLINE_OFFER_OP',
  BOT_OFFLINE = 'BOT_OFFLINE',
  SWITCH_BOT = 'SWITCH_BOT',
  SWITCH_OP = 'SWITCH_OP',
  OP_ONLINE = 'OP_ONLINE',
  OP_OFFLINE = 'OP_OFFLINE',
  OP_BUSY = 'OP_BUSY',
  OP_ONLINE_CHAT_ERR = 'OP_ONLINE_CHAT_ERR',
  OP_OFFLINE_CHAT_ERR = 'OP_OFFLINE_CHAT_ERR',
  OP_BUSY_CHAT_ERR = 'OP_BUSY_CHAT_ERR',
  OP_WAITING_FOR_GDPR_CONSENT = 'OP_WAITING_FOR_GDPR_CONSENT',
  OP_WAITING_FOR_OP_1 = 'OP_WAITING_FOR_OP_1',
  OP_WAITING_FOR_USER = 'OP_WAITING_FOR_USER',
  OP_WAITING_FOR_OP_2 = 'OP_WAITING_FOR_OP_2',
  OP_DID_START = 'OP_DID_START',
  OP_DID_NOT_START = 'OP_DID_NOT_START',
  OP_ACTIVE = 'OP_ACTIVE',
  OP_FEEDBACK = 'OP_FEEDBACK', 
  OP_FEEDBACK_DONE = 'OP_FEEDBACK_DONE', 
  
  OP_ENDED_BY_OP = 'OP_ENDED_BY_OP',
  OP_ENDED_BY_USER = 'OP_ENDED_BY_USER',
  
  OP_UNEXPECTED_ERR = 'OP_UNEXPECTED_ERR',

  OP_CONTINUE_TO_WAIT = 'OP_CONTINUE_TO_WAIT'
  }

  /*
  Reporting daktela
  */

 export enum BrowserTypeEnumSLA {
	web = 1,
	mobile = 2
}

export enum SourceIdEnumSLA {
	web = 1,
	onlineWeb = 2,
	onlineMob = 3,
	web2 = 4
}

export enum QueueAnswerEnumSLA {
	busy = 0,
	free = 1,
	offline = -1 //v pripade globalniho vypnuti
}
 export interface ReportItemSLA {
	date:string,
	time:string,
	sessionId:string,
	sourceId:SourceIdEnumSLA,
	queueAnswer:QueueAnswerEnumSLA,
	queueRequestedTime:string
}